export const ZONES_API = '/zones/';

export const ZONES_ITEMS_API = '/zones/items/';

export const ZONES_BY_ID_API = (id) => `${ZONES_API}${id}/`;

export const ZONES_ITEMS_BY_TYPE_API = (type= 'items') => `${ZONES_API}${type}/`;

export const ZONES_BY_ID_ITEMS_BY_TYPE_API = (zoneId = 1, itemType = "items") => `${ZONES_API}${zoneId}/${itemType}/`;

export const ZONES_ITEMS_COORDS_API = (id) => `${ZONES_ITEMS_API}update-coordinates/${id}/`;


// WEBPACK FOOTER //
// ./src/apis/zones.js